import { toText } from '../../../../utils/html'
import { getUserFullName, getUserId } from '../../../../utils/user'
import { getFileIconType } from '../../../FileIcon'
import {
  BIRDVIEW_LIST_SEPARATOR,
  BIRDVIEW_META_SEPARATOR,
  BIRDVIEW_PREVIEW_SEPARATOR,
  BirdviewCommunicationKind,
} from '../../DashboardBirdview.constants'
import { getBirdviewFlatNumberLabel } from '../../DashboardBirdview.utils.rows'

import { BIRDVIEW_HOME_ROW } from './useBirdviewDwellerLoaders.constants'

function getBirdviewDwellerAddress(buildings) {
  return buildings
    ?.map(building => building.title)
    .join(BIRDVIEW_META_SEPARATOR)
}

function getBirdviewFlatTitle({ number, title }, t) {
  return [title, getBirdviewFlatNumberLabel(number, t)]
    .filter(Boolean)
    .join(BIRDVIEW_META_SEPARATOR)
}

function getBirdviewChatParticipantsNames(users, userId) {
  return users
    ?.reduce((names, participant) => {
      const name = getUserFullName(participant)

      if (name && getUserId(participant) !== userId) {
        names.push(name)
      }

      return names
    }, [])
    .join(BIRDVIEW_LIST_SEPARATOR)
}

function checkIsBirdviewHomeRowKnown(row) {
  return Object.hasOwn(BIRDVIEW_HOME_ROW, row.key)
}

// A tenant with several flats gets one address row per flat under the same key.
function toBirdviewHomeItem(row, t) {
  return {
    ...BIRDVIEW_HOME_ROW[row.key],
    href: row.href,
    id: row.flat ? `${row.key}-${row.flat.id}` : row.key,
    value: getBirdviewFlatTitle(
      { number: row.flat?.number, title: row.value },
      t
    ),
  }
}

export function toBirdviewHomeSection(rows, t) {
  const items = rows
    .filter(checkIsBirdviewHomeRowKnown)
    .map(row => toBirdviewHomeItem(row, t))

  return { items, total: items.length }
}

export function toBirdviewAnnouncementItem(post) {
  return {
    address: getBirdviewDwellerAddress(post.buildings),
    id: post.id,
    published: post.published,
    title: post.title,
    unread: post.unread,
  }
}

export function toBirdviewDocumentItem(document, t) {
  return {
    address: getBirdviewFlatTitle(
      { number: document.flat?.number, title: document.building?.title },
      t
    ),
    file: document,
    fileType: getFileIconType(document),
    id: document.id,
    title: document.name,
    updated: document.created,
  }
}

export function toBirdviewMessageItem(chat, userId) {
  return {
    date: chat.updated,
    id: chat.id,
    kind: BirdviewCommunicationKind.Chat,
    subtitle: [
      getUserFullName(chat.sender),
      chat.snippet ? toText(chat.snippet) : undefined,
    ]
      .filter(Boolean)
      .join(BIRDVIEW_PREVIEW_SEPARATOR),
    title: chat.title || getBirdviewChatParticipantsNames(chat.users, userId),
    unread: chat.unread,
  }
}

export function toBirdviewDwellerRequestItem(request) {
  return {
    address: request.building?.title,
    flat: request.flat?.number,
    id: request.id,
    number: request.request_no,
    status: request.status_id,
    title: request.title,
    updated: request.updated,
  }
}

export function toBirdviewObjectItem(flat, t) {
  return {
    id: flat.id,
    open: flat.open,
    overdue: flat.overdue,
    title: getBirdviewFlatTitle(
      { number: flat.number, title: flat.building?.title },
      t
    ),
  }
}
